export class PcdDocumentos {

    static pcdDocumentosLista: PcdDocumentos[] = [
        { tipo: 'pdf', descricao: 'PCD - Quadro Comparativo', caminho: 'Regulamento_PCD_Quadro_Comparativo.pdf' },
        { tipo: 'pdf', descricao: 'PCD - Regulamento', caminho: 'Regulamento_PCD_2023.pdf' },
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/pcd-documentos.ts